function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import _ from 'lodash';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { getType } from '@cryptosheets/util';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css'; // import './JSONEditorReact.less';

export default class JSONEditorReact extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "expandAll", () => {
      this.jsoneditor.expandAll();
    });
  }

  componentDidMount() {
    // copy all properties into options for the editor
    // (except the properties for the JSONEditorReact component itself)
    var options = _objectSpread({}, this.props);

    delete options.json;
    delete options.text;
    this.jsoneditor = new JSONEditor(this.container, options);

    if ('json' in this.props) {
      this.jsoneditor.set(this.props.json);
    }

    if ('text' in this.props) {
      this.jsoneditor.setText(this.props.text);
    }

    this.schema = cloneDeep(this.props.schema);
    this.schemaRefs = cloneDeep(this.props.schemaRefs);
  }

  componentDidUpdate() {
    if ('json' in this.props) {
      this.jsoneditor.update(this.props.json); // if (getType(this.jsoneditor.expandAll) === 'function') {
      //   this.jsoneditor.expandAll();
      // }
    }

    if ('text' in this.props) {
      this.jsoneditor.updateText(this.props.text);
    }

    if ('mode' in this.props) {
      this.jsoneditor.setMode(this.props.mode);
    } // store a clone of the schema to keep track on when it actually changes.
    // (When using a PureComponent all of this would be redundant)


    var schemaChanged = !isEqual(this.props.schema, this.schema);
    var schemaRefsChanged = !isEqual(this.props.schemaRefs, this.schemaRefs);

    if (schemaChanged || schemaRefsChanged) {
      this.schema = cloneDeep(this.props.schema);
      this.schemaRefs = cloneDeep(this.props.schemaRefs);
      this.jsoneditor.setSchema(this.props.schema, this.props.schemaRefs);
    }
  }

  componentWillUnmount() {
    if (this.jsoneditor) {
      this.jsoneditor.destroy();
    }
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "jsoneditor-react-container",
      style: {
        width: '100%',
        height: '100%'
      },
      ref: elem => this.container = elem
    }));
  }

}